import { graphql } from '@/gql';

export const GET_ARBEITSBEREICHE_BY_STANDORT_ID = graphql(`
  query dienstplan_arbeitsbereichByStandortId($standortId: String!) {
    dienstplan_arbeitsbereich(standortId: $standortId) {
      id
      markierung
      mindestbelegung {
        belegungen {
          anzahlMitarbeiter
          dauer
          id
          von
        }
        einstellungen {
          bemerkung
          maxAnzahlMitarbeiter
          unbesetzteSchichten
          zielabsatzproduktivitaet {
            mpt
            stueckzahl
          }
          zielumsatzproduktivitaet
        }
        tag
      }
      name
    }
  }
`);
